import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { WebhookPayloadVersion } from "@signalist/shared-types";

import { Radio } from "@/components/Radio/Radio";

/** The choices, newest first, each with its own label keys (never a version interpolated into text). */
export const WEBHOOK_PAYLOAD_VERSION_OPTIONS: ReadonlyArray<{
	version: WebhookPayloadVersion;
	labelKey: string;
	hintKey: string;
}> = [
	{
		version: 2,
		labelKey: "webhookLists.payloadVersion.v2",
		hintKey: "webhookLists.payloadVersion.v2Hint",
	},
	{
		version: 1,
		labelKey: "webhookLists.payloadVersion.v1",
		hintKey: "webhookLists.payloadVersion.v1Hint",
	},
];

interface WebhookPayloadVersionFieldProps {
	value: WebhookPayloadVersion;
	onChange: (version: WebhookPayloadVersion) => void;
}

/**
 * Which body the webhook receives (PREC-4251): the v2 envelope, or the v1 lead array existing
 * integrations were built on. Shown in the Create and Edit Webhook dialogs.
 */
export const WebhookPayloadVersionField: FunctionComponent<WebhookPayloadVersionFieldProps> = ({
	value,
	onChange,
}) => {
	const { t } = useTranslation();

	return (
		<div className="flex flex-col gap-2 mb-4" data-test="webhook-payload-version">
			<div className="text-ssm font-medium">{t("webhookLists.payloadVersion.label")}</div>
			{WEBHOOK_PAYLOAD_VERSION_OPTIONS.map(({ version, labelKey, hintKey }) => (
				<div key={version} className="flex flex-col">
					<Radio
						isChecked={value === version}
						name="payloadVersion"
						testId={`webhook-payload-version-${version}`}
						value={String(version)}
						onChange={() => onChange(version)}
					>
						{t(labelKey)}
					</Radio>
					<span className="ml-7 text-xs text-text-meta">{t(hintKey)}</span>
				</div>
			))}
		</div>
	);
};
